<template>
  <base-info-card title="Galería">
    <v-row dense>
      <v-col
        v-for="n in 9"
        :key="n"
        cols="auto"
      >
        <base-img
          :src="require(`@/assets/gal-${n}.jpg`)"
          color="grey lighten-1"
          width="103"
          tile
        />
      </v-col>
    </v-row>
  </base-info-card>
</template>

<script>
  export default {
    name: 'Galería',
  }
</script>
